import type { SxProps, Theme } from '@mui/material/styles';
import { MOBILE_DIALOG_OFFSET_HEIGHT } from './constants';

export const dialogPaperSx: SxProps<Theme> = {
  top: 0,
  left: 0,
  height: `calc(100vh - ${MOBILE_DIALOG_OFFSET_HEIGHT}px)`,
  maxHeight: `calc(100vh - ${MOBILE_DIALOG_OFFSET_HEIGHT}px)`,
  m: 0,
  borderRadius: 0,
  boxShadow: 'none',
  backgroundColor: 'white',
  border: 'none',
  width: '100vw',
  maxWidth: '100vw',
};

export const dialogRootSx: SxProps<Theme> = {
  '& .MuiDialog-container': {
    alignItems: 'flex-start',
    padding: 0,
    margin: 0,
  },
  '& .MuiPaper-root': {
    m: -1,
    p: 0,
  },
};

export const dialogTitleSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 2,
  borderBottom: '1px solid rgba(0,0,0,0.1)',
};

export const dialogTitleTextSx: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: '1.25rem',
  color: 'text-gray-800',
};
